import React from 'react'
import { Col, Row, TabPane } from 'reactstrap'
import CumstomField from '../../../../../components/Common/CustomFields';

const NoteTab = (props) => {

    const { form, disabled } = props;
    
    return(
        <TabPane tabId="4" className="p-3">
          <Row>
            <Col lg="6">
            
             <CumstomField
            {...form?.getInput("note")}
            label=""
            maxLength="225"
            type="textarea"
            rows="3"
            disabled={disabled}
          />
            </Col>
            
          </Row>
        </TabPane>
    )
}

export default NoteTab